import { render, staticRenderFns } from "./TripWagonImportPlanning.vue?vue&type=template&id=0a8b0a2b&scoped=true"
import script from "./TripWagonImportPlanning.vue?vue&type=script&lang=js"
export * from "./TripWagonImportPlanning.vue?vue&type=script&lang=js"
import style0 from "./TripWagonImportPlanning.vue?vue&type=style&index=0&id=0a8b0a2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8b0a2b",
  null
  
)

export default component.exports